// GAME ACTION TYPES
export const SHOT = "SHOT"
export const SHOT_MISS = "SHOT_MISS"
export const START_GAME = "START_GAME"
export const GAME_OVER = "GAME_OVER"
